<template>
  <div class="operation" id="operation">
    <head-search
      @searchQuery="search"
      @searchCancel="onCancel"
      placeholder="搜索"
    ></head-search>
    <div class="operation-box">
      <van-list
        class="operation-list"
        v-model="refreshConfig.loading"
        :finished="refreshConfig.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="list-item-box"
          v-for="(item, index) of list"
          :key="index"
          @click="_itemClicked(item)"
        >
          <div class="cell-title">{{ item.BT }}</div>
          <img
            class="arrowIcon"
            :src="require('@/assets/img/projectProgress/jiantou.png')"
          />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import HeadSearch from '@/components/HeadSearch.vue'
import comListMixins from '@/mixins/comListMixins'
import moduleMixins from '@/mixins/moduleMixins'

export default {
  name: 'CommonHome',
  components: {HeadSearch},
  mixins: [comListMixins, moduleMixins],
  props: {},
  data() {
    return {
      list: [],
      searchValue: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    _itemClicked(item) {
      this.itemClicked(item)
    },
    search(val) {
      console.log('搜索值', val)
      this.searchValue = val
      this.onRefresh()
    },
    onCancel() {
      console.log('点击取消')
      this.searchValue = ''
      this.onRefresh()
    }
  },
  created() {},
  mounted() {}
}
</script>
<style lang="scss" scoped>
.operation {
  background: #ffffff;
  height: 100vh;
  width: 100%;
  .operation-box {
    padding-top: 47px;
  }
  .operation-list {
    .list-item-box {
      display: flex;
      padding: 18px 15px;
      align-items: center;
      justify-content: space-between;
      background: #ffffff;
      border-bottom: 1px solid #f1f3f6;
      &:active {
        background: #f9fbff;
      }
      .cell-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .arrowIcon {
        width: 7px;
        height: 12px;
        margin-left: 10px;
      }
    }
  }
}
</style>
